
import React, { ReactNode } from 'react';
import { ProcessingProvider } from '../context/processing/ProcessingContext';
import { VezgoProvider } from '../context/VezgoContext';

interface VezgoProviderWrapperProps {
  children: ReactNode;
  initialProvider?: string;
}

export const VezgoProviderWrapper: React.FC<VezgoProviderWrapperProps> = ({ children, initialProvider }) => {
  return (
    <ProcessingProvider>
      <VezgoProvider initialProvider={initialProvider}>
        {children}
      </VezgoProvider>
    </ProcessingProvider>
  );
};
